const __ = (e) => {

	if ( e in window[ 'wwp3translations' ] ) {

		return window[ 'wwp3translations' ][e];

	}

	if ( console && console.log ) {

		if ( ! ( 'wwp3translations_missing' in window ) ) {

			window.wwp3translations_missing = [];

		}

		if ( window.wwp3translations_missing.indexOf( e ) === -1 ) {

			window.wwp3translations_missing.push( e );

		}

		console.log( 'Missing WWP3 Translations:' );
		console.dir( window.wwp3translations_missing );

	}

	return e;

};

export default __


// WEBPACK FOOTER //
// src/assets/js/react/utils/i18n.js